<template>
  <div>
  <v-card 
    class="mx-auto"
    max-width="344"
  >
    <v-card-text v-if="!loading">
      <v-text-field
        v-model="sensor.id"
        label="Χαρακτηριστικό (id)"
        disabled
      ></v-text-field>

      <v-text-field
        v-model="sensor.authKey"
        disabled
        label="Κλειδί (auth key)"
      ></v-text-field>

      <v-text-field
        v-model="sensor.description"
        label="Περιγραφή"
        :disabled="!canEdit"
      ></v-text-field>

      <v-text-field
        type="number"
        v-model.number="sensor.latitude"
        :disabled="!canEdit"
        label="Γεωγραφικό Πλάτος (Latitude)"
      ></v-text-field>

      <v-text-field
        type="number"
        v-model.number="sensor.longitude"
        :disabled="!canEdit"
        label="Γεωγραφικό Μήκος (Longitude)"
      ></v-text-field>

      <CampPicker :camps="camps" :disabled="!canEdit" :limit="1" ref="campPicker"/>

      <v-text-field
        v-model="computedOrientations"
        :disabled="!canEdit"
        label="Κατευθύνσεις Αισθητήρων"
      ></v-text-field>

    </v-card-text>

    <v-spacer></v-spacer>

    <p class="font-weight-regular" style="color: red;">
      {{ error }}
    </p>

    <v-card-actions>
          <v-btn
            color="blue"
            :disabled="!canEdit"
            :loading="loading"
            @click="save"
          >ΑΠΟΘΗΚΕΥΣΗ ΑΛΛΑΓΩΝ</v-btn>


          <v-dialog
            v-model="dialog"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!canEdit"
              :loading="loading"
              v-bind="attrs"
              v-on="on"
              color="red"
              class="ml-2"
            >ΔΙΑΓΡΑΦΗ</v-btn>
            </template>

            <v-card>
              <v-card-title>
                Επιβεβαίωση
              </v-card-title>

              <v-card-text>
                  Είστε σίγουρος πως θέλετε να διαγράψετε τον αισθητήρα;
                  Αυτή η ενέργεια είναι μη αντιστρέψιμη.
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red"
                  @click="deleteSensor"
                >
                  Ναι, ΔΙΑΓΡΑΦΗ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    </v-card-actions>
  </v-card>

  <div v-if="this.sensorId">
    <v-divider class="mt-2 mb-2"></v-divider>
    <EventManagement :sensorIdFilter="sensorId" :hideToolbar="true"/>
  </div>
  </div>
</template>

<script>
import EventManagement from '@/views/EventManagement.vue'
import CampPicker from '@/components/CampPicker.vue'

export default {
  name: 'SensorDetails',
  props: {
    sensorId: {
      type: String,
      default: undefined,
      required: false
    },
    createNew: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    EventManagement,
    CampPicker
  },
  data: () => {
      return {
          loading: true,
          sensor: {
              id: "",
              authKey: "",
              description: "",
              latitude: "",
              longitude: "",
              orientations: ["0", "120", "240"]
          },
          camps: [],
          error: "",
          dialog: false
      }
  },
  async mounted() {
    if (this.createNew) {
      this.loading = false
      return
    }
    await this.load()
  },
  watch: {
    sensorId: {
      handler: async function() {
        await this.load()
      }
    }
  },
  computed: {
        computedOrientations: {
            get () {
                return this.sensor.orientations.join()  
            },
            set (val) {
                this.sensor.orientations = val.replace(/ /g,'').split(',')
            }
        },
        canEdit() {
          return this.$store.state.user.isAdmin
        }
    },
    methods: {
        async deleteSensor() {
            this.loading = true
            try {
                const response = await this.$axios.delete('/sensors/', { params: { id: this.sensorId } })
                console.log(response)
                this.error = `Successfully Deleted sensor ${this.sensorId}`
                // this.$router.replace('/sensors')
            } catch (e) {
                console.log(e)
                this.error = e.response.data
            }
            this.loading = false
            this.dialog = false
        },
        async load(){
            this.loading = true
            try {
                const response = await this.$axios.get('/sensors', { params: { id: this.sensorId } })
                this.sensor = Object.assign({}, this.sensor, response.data)
                this.camps = [response.data.camp]

                this.error = ""
            } catch (e) {
                console.log(e.response.data)
                this.error = e.response.data
            }
            this.loading = false
        },
        async save() {
          const payload = {
              description: this.sensor.description,
              latitude: this.sensor.latitude,
              longitude: this.sensor.longitude,
              orientations: this.sensor.orientations.map(x => parseFloat(x)),
              camp: this.$refs.campPicker.selectedCamps[0]
          }
          console.log(this.camps)
          console.log(payload)

          if (!this.createNew) {
            payload['id'] = this.sensor.id
          }

          // console.log(payload)
          try {
            const response = await this.$axios.put('/sensors/', payload)
            if (this.createNew) {
              this.sensorId = response.data
            }
          } catch (e) {
              console.log(e.response.data)
              this.error = e.response.data
              return
          }
          await this.load()
        }
    }
}
</script>
